import React from "react";
import SensorBase from "./SensorBase";
import IrrigationHour from "../../../components/IrrigationHour";

const FIELD = "moisture1";
const UNIT = "%";

const Moisture1: React.FC = () => {
  return (
    <div>
      <SensorBase field={FIELD} unit={UNIT}></SensorBase>
      <IrrigationHour />
    </div>
  );
};

export default Moisture1;
